import { TFormValidation, TFormValue, IFormConfig } from './useForm.types';

const validationTypes = {
  NO_SPECIAL_CHARACTERS: 'NO_SPECIAL_CHARACTERS',
};

const validationConfig = {
  NO_SPECIAL_CHARACTERS: {
    regex: new RegExp(/[^A-Za-z0-9]/),
    message: 'No special characters allowed',
  },
};

export const generateInitialFormErrors = (formConfig: IFormConfig) => {
  return Object.keys(formConfig).reduce((errors, fieldName) => {
    return {
      ...errors,
      [fieldName]: [],
    };
  }, {});
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const validateFieldWithStandardValidation = (validationType: string, value: TFormValue, label: string) => {
  let errorMessage = null;

  switch (validationType) {
    case validationTypes.NO_SPECIAL_CHARACTERS:
      if (validationConfig.NO_SPECIAL_CHARACTERS.regex.test(value as string)) {
        errorMessage = validationConfig.NO_SPECIAL_CHARACTERS.message;
      }
      break;

    default:
      console.warn('Validation type not valided');
  }

  return errorMessage;
};

export const getFieldErrors = (fieldValidation: TFormValidation, valueToValidate: TFormValue) => {
  let errors: Array<string> = [];

  if (fieldValidation.validationType) {
    const newErrors = validateFieldWithStandardValidation(
      fieldValidation.validationType,
      valueToValidate,
      fieldValidation.label,
    );

    if (newErrors) {
      errors = [...errors, newErrors];
    }
  }

  if (fieldValidation.customValidationCallback) {
    errors = [...fieldValidation.customValidationCallback(valueToValidate)];
  }

  if (fieldValidation.isRequired && (!valueToValidate || valueToValidate.length === 0)) {
    errors = [...errors, `We need your ${fieldValidation.label}`];
  }

  if (
    fieldValidation.maxLength &&
    typeof valueToValidate?.length === 'number' &&
    valueToValidate.length > fieldValidation.maxLength
  ) {
    errors = [...errors, `Maximum character length is ${fieldValidation.maxLength}`];
  }

  return errors;
};

export const generateFormErrors = <T extends Record<string, any>>(formConfig: IFormConfig, formState: T) => {
  const formErrors = Object.keys(formConfig).reduce((updatedFormErrors, fieldName) => {
    const fieldValidation = formConfig[fieldName];
    const fieldValue = formState[fieldName];

    return {
      ...updatedFormErrors,
      [fieldName]: getFieldErrors(fieldValidation, fieldValue),
    };
  }, {});

  return formErrors;
};
